/**
 * @fileoverview Step 3 (company address) UI for the Register page.
 * @module pages/register/RegisterStep3
 */
import Select from "react-select";
import {
  filterSelectOptionByCodigo,
  filterSelectOptionByNombre,
  getSelectOptionCodigo,
  getSelectOptionId,
} from "./registerFormHelpers.js";
import styles from "../../styles/Register.module.css";

const RegisterStep3 = ({
  t,
  values,
  countries,
  states,
  towns,
  zipCodes,
  neighborhoods,
  countryRef,
  stateRef,
  townRef,
  zipCodeRef,
  neighborhoodRef,
  notSingleSelectStyles,
  getSafeSelectedOption,
  noOptionsMessage,
  formatOptionNombreLabel,
  formatOptionCodigoLabel,
  handleNamedInputChange,
  handleCountryChange,
  handleZipCodeChange,
  handleStateChange,
  handleTownChange,
  handleNeighborhoodChange,
}) => (
  <div className={styles.formStep3}>
    <div className={styles.formStepTitle}>
      3. {t("pages.register.step3Title1")}{" "}
      <span className={styles.formStepTitle2}>
        {t("pages.register.step3Title2")}
      </span>
    </div>

    <div className={styles.formRow}>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          *{t("pages.register.streetLabel")}
        </div>
        <div className={styles.formInput}>
          <input
            type="text"
            name="calle"
            value={values.calle}
            onChange={handleNamedInputChange}
            className={styles.formNotSingleInput}
            placeholder={t("pages.register.streetPlaceholder")}
          />
        </div>
      </div>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          *{t("pages.register.exteriorNumberLabel")}
        </div>
        <div className={styles.formInput}>
          <input
            type="text"
            name="numeroExterior"
            value={values.numeroExterior}
            onChange={handleNamedInputChange}
            className={styles.formNotSingleInput}
            placeholder={t("pages.register.exteriorNumberPlaceholder")}
          />
        </div>
      </div>
    </div>

    <div className={styles.formRow}>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          {t("pages.register.interiorNumberLabel")}
        </div>
        <div className={styles.formInput}>
          <input
            type="text"
            name="numeroInterior"
            value={values.numeroInterior}
            onChange={handleNamedInputChange}
            className={styles.formNotSingleInput}
            placeholder={t("pages.register.interiorNumberPlaceholder")}
          />
        </div>
      </div>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          {!values.esExtranjero ? "*" : ""}
          {t("pages.register.countryLabel")}
        </div>
        <Select
          ref={countryRef}
          isSearchable={true}
          filterOption={filterSelectOptionByNombre}
          noOptionsMessage={noOptionsMessage}
          value={getSafeSelectedOption(countries, values.pais)}
          onChange={handleCountryChange}
          options={countries}
          placeholder={t("pages.register.countryPlaceholder")}
          styles={notSingleSelectStyles}
          className="select__control"
          getOptionValue={getSelectOptionId}
          formatOptionLabel={formatOptionNombreLabel}
        />
      </div>
    </div>

    <div className={styles.formRow}>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          *{t("pages.register.zipCodeLabel")}
        </div>
        <Select
          ref={zipCodeRef}
          isSearchable={true}
          filterOption={filterSelectOptionByCodigo}
          noOptionsMessage={noOptionsMessage}
          value={getSafeSelectedOption(zipCodes, values.codigoPostal)}
          onChange={handleZipCodeChange}
          options={zipCodes}
          placeholder={t("components.location.postalCodePlaceholder")}
          styles={notSingleSelectStyles}
          className="select__control"
          getOptionValue={getSelectOptionId}
          formatOptionLabel={formatOptionCodigoLabel}
        />
      </div>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          {!values.esExtranjero ? "*" : ""}
          {t("pages.register.stateLabel")}
        </div>
        <Select
          ref={stateRef}
          isSearchable={true}
          filterOption={filterSelectOptionByNombre}
          noOptionsMessage={noOptionsMessage}
          value={getSafeSelectedOption(states, values.estado)}
          onChange={handleStateChange}
          options={states}
          placeholder={t("components.location.statePlaceholder")}
          styles={notSingleSelectStyles}
          className="select__control"
          getOptionValue={getSelectOptionId}
          formatOptionLabel={formatOptionNombreLabel}
        />
      </div>
    </div>

    <div className={styles.formRow}>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          {!values.esExtranjero ? "*" : ""}
          {t("pages.register.townLabel")}
        </div>
        <Select
          ref={townRef}
          isSearchable={true}
          filterOption={filterSelectOptionByNombre}
          noOptionsMessage={noOptionsMessage}
          value={getSafeSelectedOption(towns, values.municipio)}
          onChange={handleTownChange}
          placeholder={t("components.location.townPlaceholder")}
          options={towns}
          styles={notSingleSelectStyles}
          className="select__control"
          getOptionValue={getSelectOptionId}
          formatOptionLabel={formatOptionNombreLabel}
        />
      </div>
      <div className={styles.formColumn}>
        <div className={styles.formLabel}>
          {!values.esExtranjero ? "*" : ""}
          {t("pages.register.neighborhoodLabel")}
        </div>
        <Select
          ref={neighborhoodRef}
          isSearchable={true}
          filterOption={filterSelectOptionByNombre}
          noOptionsMessage={noOptionsMessage}
          value={getSafeSelectedOption(neighborhoods, values.colonia)}
          onChange={handleNeighborhoodChange}
          options={neighborhoods}
          placeholder={t("components.location.neighborhoodPlaceholder")}
          styles={notSingleSelectStyles}
          className="select__control"
          getOptionValue={getSelectOptionId}
          formatOptionLabel={formatOptionNombreLabel}
        />
      </div>
    </div>

    <p className={styles.formInstructions}>
      *{t("pages.register.markedFieldsAreRequired")}
    </p>
  </div>
);

export default RegisterStep3;
